import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=654cdb1e&scoped=true&"
import script from "./OrderAddress.vue?vue&type=script&lang=ts&"
export * from "./OrderAddress.vue?vue&type=script&lang=ts&"
import style0 from "./OrderAddress.vue?vue&type=style&index=0&id=654cdb1e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654cdb1e",
  null
  
)

export default component.exports